export default (env = process.env) => ({
  stripeSDK: "https://js.stripe.com/v3/",
});
